export const LOGIN_URL = '/auth/login';

// Setting Management

// Languages
export const LANGAUGE_URL = '/languages'

// Roles
export const ROLE_URL = '/roles'

// Sessions
export const SESSION_URL = '/sessions'

// Adcademic Management

// Sections
export const SECTION_URL = '/sections'

// Classes
export const CLASS_URL = '/classes'

// Subjects
export const SUBJECT_URL = '/subjects'

// Subject Groups
export const SUBJECTGROUP_URL = '/subject-groups'

// SMS Templete
export const SMSTEMPLETE_URL = '/sms-templates'

// Email Templete
export const EMAILTEMPLETE_URL = '/email-templates'

